export default {
  name: "ClockRecord",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};